const getters={
  getErrors: (state) => state.errors,
  getIsPaymentSuccess: (state) => state.isPaymentSuccess,
  getUpgradeButtonVisibilityStatus: (state) => state.upgradeButtonVisibilityStatus
}
export default getters



// WEBPACK FOOTER //
// ./src/store/modules/payment/getters.js